import { ScrollBar } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { CSSProperties, ReactNode, useLayoutEffect, useRef, useState } from "react";
import { ScrollContainerRefContext } from "./scroll.container.ref.context";

interface TanstackTableProps {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

export const TanstackTable = ({ className, style, children }: TanstackTableProps) => {
  const viewportRef = useRef<HTMLDivElement>(null);
  const [isRefReady, setIsRefReady] = useState(false);

  useLayoutEffect(() => {
    if (viewportRef.current) {
      setIsRefReady(true);
    }
  }, []);

  return (
    <ScrollAreaPrimitive.Root
      className={cn(
        "border rounded-md transition-width duration-300 h-full overflow-hidden pr-2 pb-2",
        className
      )}
    >
      <ScrollAreaPrimitive.Viewport ref={viewportRef} className="h-full rounded-[inherit]">
        <ScrollContainerRefContext.Provider value={isRefReady ? viewportRef : null}>
          <div style={style}>{children}</div>
        </ScrollContainerRefContext.Provider>
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar orientation="vertical" />
      <ScrollBar orientation="horizontal" />
    </ScrollAreaPrimitive.Root>
  );
};
